class IbeConfig {
  parkName: string;

  latitude: number;

  longitude: number;
}

export default IbeConfig;
